{
  "de": {
    "contact": {
      "actions": {
        "accept": "OK",
        "add": "Kontakt hinzufügen",
        "add_type": "{type} hinzufügen",
        "backInspirationLists": "Zurück zu den Inspirationslisten",
        "cancelNew": "Rückgängig machen",
        "deactivateEmployee": "Deaktivieren",
        "deleteCustomer": "Kunden löschen …",
        "deleteEmployee": "Teammitglied löschen …",
        "deleteLead": "Lead löschen …",
        "deletePartner": "Partner löschen …",
        "delete_contact": "Löschen",
        "edit": "Bearbeiten",
        "impersonate": "Identität übernehmen",
        "impersonateStart": "Schreiten Sie durch das orangefarbene Portal, um die Welt von {name} zu entdecken.",
        "impersonateStop": "Zurück in Ihre eigene Welt",
        "invite": "Einladung senden",
        "newTicket": "Neue Konversation",
        "reactivateEmployee": "Reaktivieren",
        "resendInvitationEmail": "Einladungs-E-Mail erneut senden",
        "searchContact": "Kontakt suchen",
        "searchCustomer": "Kunden suchen",
        "searchEmployee": "Teammitglied suchen",
        "selectAll": "Alle {total} Kontakte auswählen",
        "selectOption": "Option auswählen",
        "setProfilePicture": "Profilbild festlegen",
        "showall": "Alle anzeigen",
        "unSelectAll": "Auswahl aufheben."
      },
      "attributes": {
        "language": "Sprache",
        "timezone": "Zeitzone",
        "title": "Anrede"
      },
      "labels": {
        "address": "Adresse",
        "all": "Alle Kontakte",
        "back_to_overview": "Zurück zur Übersicht",
        "cannot_create_role": "Wenden Sie sich an einen Inhaber, um einen neuen Kontakt zu erstellen",
        "cannot_delete": "Dieser Nutzer kann nicht gelöscht werden (Integration)",
        "company": "Organisation",
        "company_all": "Alle Organisationen",
        "contact_status": {
          "active": "Aktiv",
          "added": "Noch nicht eingeladen",
          "all": "Alle Status",
          "blocked": "Deaktiviert",
          "invited": "Eingeladen",
          "status": "Status"
        },
        "contact_type": "Typ",
        "customer": "Kunde",
        "customers": "Kunden",
        "employee": "Team",
        "export_contacts": "Kontakte exportieren",
        "general": "Allgemein",
        "impersonateInactiveProfile": "Diese großartige Person ist noch nicht aktiv. Bitte aktivieren Sie zuerst den Kunden.",
        "invite": "Ja, Kontakte einladen",
        "inviteProfileFirstCustomer": "Laden Sie den Kunden zuerst zur Plattform ein, um eine Nachricht zu senden, die Identität zu übernehmen oder die Einladungs-E-Mail erneut zu senden",
        "inviteProfileFirstPartner": "Laden Sie den Partner zuerst zur Plattform ein, um die Identität zu übernehmen oder die Einladungs-E-Mail erneut zu senden",
        "last_login": "Letzte Anmeldung",
        "last_seen": "zuletzt gesehen",
        "last_seen_not_seen_yet": "noch keine Anmeldung",
        "lead": "Lead",
        "name": "Name",
        "name_or_email_address": "Name oder E-Mail-Adresse",
        "name_or_email_address_phone": "Name, E-Mail-Adresse oder Telefon",
        "noContacts": "Keine Kontakte",
        "no_contacts": "Keine Kontakte zum Exportieren",
        "no_contacts_results": "Diese Suche hat keine Ergebnisse. Probieren Sie andere Filter aus, um die richtige Person zu finden.",
        "no_contacts_results_subtitle": "Diese Suche hat keine Ergebnisse. Probieren Sie andere Filter aus, um die richtige Person zu finden.",
        "no_contacts_results_title": "Keine Kontakte gefunden",
        "number_contacts": "Keine Kontakte | 1 Kontakt | {count} Kontakte",
        "other": "Sonstiges",
        "partner": "Partner",
        "partners": "Partner",
        "project": "Projekt",
        "secondary_contact": "Sekundärer Kontakt",
        "selectOne": "Wählen Sie mindestens 1 Kontakt aus",
        "selectProjectForImpersonation": "Für welches Projekt möchten Sie die Identität von {customer_name} übernehmen?",
        "selected": "{selected} Kontakt ausgewählt. | {selected} Kontakte ausgewählt.",
        "sorting": {
          "last_name": "Name",
          "session_started_at": "Letzte Anmeldung",
          "status": "Status"
        },
        "totalSelected": "Alle {total} Kontakte sind ausgewählt.",
        "units": "Einheiten"
      },
      "navigation": {
        "backToContacts": "Zurück zu Kontakten"
      },
      "placeholders": {
        "byNameOrEmailAddress": "Nach Name oder E-Mail-Adresse"
      },
      "validation": {
        "emailTaken": "E-Mail-Adresse entspricht der vorherigen",
        "mustBeEmailAddress": "Gültige E-Mail-Adresse erforderlich",
        "requireEmailAddress": "E-Mail-Adresse erforderlich"
      }
    }
  }
}
